import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 18820 11204"
    {...props}
  >
    <path
      d="M2616 6520c77 0 157 5 235 16l221 29c95 13 191-14 266-74s122-150 130-245l18-225c44-558 294-1076 703-1459 409-384 943-595 1502-595 1221-1 2214 1003 2214 2237 0 49-2 101-6 154l-17 253c-7 104 32 204 107 276s177 108 279 96l251-25c61-8 125-11 187-11 922 0 1672 711 1672 1584 1 869-746 1579-1666 1585H2606c-975-6-1769-812-1769-1798 0-992 798-1798 1779-1798zm8337-5683c1959 0 3552 1609 3552 3587 0 83-3 166-8 249-7 102 32 203 106 275 75 71 177 107 280 96s208-17 309-17c1540 0 2791 1197 2791 2669 1 1464-1245 2662-2775 2670h-4700c316-417 503-918 534-1444 23-127 37-258 37-391 1-892-535-1667-1312-2043-345-216-741-360-1168-411-39-902-481-1699-1151-2212 267-1741 1735-3028 3505-3028zm-8353 9979 43 1h6048l28-1c195-1 383-28 564-71 2 24 2 48 9 72 45 149 182 250 336 250h5583c1916-10 3473-1522 3473-3371 0-1854-1559-3363-3480-3369-51-2319-1938-4191-4251-4191-2028 0-3723 1410-4145 3354-345-143-722-224-1117-224-738 0-1442 279-1981 784-503 471-822 1097-909 1776C1352 5717 136 6878 136 8318c1 1370 1106 2490 2464 2498z"
      style={{
        fill: "#322d2c",
        // stroke: "#000",
        strokeWidth: 272.759,
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
